import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Breadcrumb } from '@core/models/breadcrumb/breadcrumb.model';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { ResetBrandAction, SetBreadcrumbAction } from '@ngxs-store/breadcrumb-store/breadcrumb.actions';
import { BreadcrumbState } from '@ngxs-store/breadcrumb-store/breadcrumb.state';
import { Navigate } from '@ngxs/router-plugin';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-breadcrumb-footer',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent implements OnInit {
    @Input() isHomePage: boolean = false;

    breadcrumbItems$: Observable<Breadcrumb[]>;
    hasValidToken = false;
    routeSub: Subscription;

    constructor(private store: Store, private router: Router, private route: ActivatedRoute) { }

    ngOnInit(): void {
        this.hasValidToken = this.store.selectSnapshot(AuthState.getHasValidToken);

        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (this.router.url.toLowerCase().includes('images') && !this.hasValidToken) {
                this.store.dispatch(new Navigate(['']));
            } else {
                const breadcrumbs: Breadcrumb[] = [];

                let url = ''
                const urlSegments = this.router.url.split('?')[0].split('/');
                const params = this.router.getCurrentNavigation().finalUrl.queryParams;
                urlSegments.forEach((segment, i) => {
                    if (segment !== '') {
                        url += '/' + segment;
                    }

                    // catering for product categories, sub categories and brand to be in breadcrumb
                    if (i == 1 && Object.keys(params).length > 0) {
                        let urlWithParams = url;

                        if (params.category) {
                            urlWithParams += '?category=' + params.category;

                            const homeBreadcrumb = breadcrumbs.find((f) => f.text.toLowerCase() == params.category.toLowerCase());
                            if (homeBreadcrumb) {
                                homeBreadcrumb.currentUrl = urlWithParams;
                            } else {
                                breadcrumbs.push(new Breadcrumb(params.category, urlWithParams, false, false));
                            }
                        }

                        if (params.subCategory) {
                            urlWithParams += '&subCategory=' + encodeURIComponent(params.subCategory);
                            breadcrumbs.push(new Breadcrumb(params.subCategory, urlWithParams, false, false));
                        } else if (params.brand) {
                            urlWithParams += '&brand=' + params.brand;
                            breadcrumbs.push(new Breadcrumb(params.brand, urlWithParams, false, false));
                        }

                        if (params.subCategory3) {
                            urlWithParams += '&subCategory3=' + encodeURIComponent(params.subCategory3);
                            breadcrumbs.push(new Breadcrumb(params.subCategory3, urlWithParams, false, false));
                        }

                        if (params.subCategory4) {
                            urlWithParams += '&subCategory4=' + encodeURIComponent(params.subCategory4);
                            breadcrumbs.push(new Breadcrumb(params.subCategory4, urlWithParams, false, false));
                        }
                    } else {
                        if (!urlSegments.includes('auth')) {
                            breadcrumbs.push(new Breadcrumb(segment === '' ? 'Home' : segment, url, false, false));
                        }
                    }
                });

                this.store.dispatch(new SetBreadcrumbAction({ breadcrumbs }));
            }
        });

        this.breadcrumbItems$ = this.store.select(BreadcrumbState.getItems);
    }

    shouldDisplayImage(): boolean {
        // Check if the category parameter in the URL is set to "FEATURED"
        const isFeaturedCategory = this.route.snapshot.queryParams['category'] === 'FEATURED';

        // Check if it's the home page (no category parameter in the URL)
        const isHomeCategory = this.route.snapshot.queryParams['category'] &&
            this.route.snapshot.queryParams['category'].toLowerCase() === 'home';

        // Check if the URL contains "FEATURED&"
        const urlContainsFeatured = this.router.url.includes('FEATURED&');
        const urlContainsHome = this.router.url.includes('Home&');
        const urlContainshome = this.router.url.includes('home&');

        // Display the image if it's either the featured category or the home page
        return (isFeaturedCategory || isHomeCategory) && !urlContainsFeatured && !urlContainsHome && !urlContainshome;
    }


    navigate(item: Breadcrumb, index: number) {
        this.router.navigateByUrl(item.currentUrl);
    }

}
